exports = module.exports = require("../../../../../scratch-gui/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html,body{\n    padding:0;\n    margin:0;\n}\n.blocks-only_controls_1Fuds {\n    position: absolute;\n    z-index: 2;\n    top: 10px;\n    right: 15px;\n}\n", ""]);

// exports
exports.locals = {
	"controls": "blocks-only_controls_1Fuds"
};